/*
 * Copyright 1999-2024 Jagex Ltd.
 */
import styled from '@emotion/styled';
import { MEDIA_SCREEN_BREAKPOINTS } from '@common/constants';
import { Flex } from '@components/common/primitives';

// Styles for box from RuneScape. Need to do something with it.
export const ContentContainer = styled(Flex)`
  position: relative;
  background-color: rgb(16, 29, 35);
  box-shadow: 0 0.1875rem 0.1875rem 0 #071820, inset 0 0.0625rem 0.0625rem 0 rgba(145, 181, 197, 0.75);
  padding: 0.5rem;

  &:before {
    box-shadow: 0 0.0625rem 0.125rem 0 rgba(145, 181, 197, 0.75), inset 0 0.1875rem 0.1875rem 0 #071820;
    content: '';
    height: calc(100% - 0.875rem);
    left: 0.4375rem;
    pointer-events: none;
    position: absolute;
    top: 0.4375rem;
    width: calc(100% - 0.875rem);

    @media (max-width: ${MEDIA_SCREEN_BREAKPOINTS.s}) {
      box-shadow: none;
    }
  }

  @media (max-width: ${MEDIA_SCREEN_BREAKPOINTS.s}) {
    padding-bottom: 2.4375rem;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
  }
`;
